import { Action, createActionGroup, emptyProps, props } from "@ngrx/store";
import { UpdateJobMutation } from "graphql.generated";

import { ActionSource } from "../../../state/action-sources";

export const CloseJobComponentActions = createActionGroup({
  source: ActionSource.CLOSE_JOB_COMPONENT,
  events: {
    'Closure Reason Selected': props<{ closedReason: string }>(),
    'Exit Dialog Button Clicked': emptyProps(),
    'Dialog Prompted': props<{ promptedBy: Action }>(),
    'Close Job Button Clicked': emptyProps(),
    'Close Job Success': props<{ updatedJob: UpdateJobMutation['updateJobs']['jobs'][0] }>(),
    'Close Job Error': props<{ error: Error }>(),
  },
});
